<div class="form-group product__option" *ngIf="initialized">
    <div class="row mobile:justify-center">
        <div class="col-auto">
            <mat-calendar #calendar class="w-64"
                [selected]="selectedDate"
                [minDate]="today"
                [maxDate]="maxDate"
                [dateFilter]="dateFilter"
                (selectedChange)="onSelect($event)"
            >
            </mat-calendar>
        </div>
        <div class="col">
            <div class="times-select slots m-0"*ngIf="timeType == 'time_slots'">
                <app-timeslot-view [product]="product" [timeslots]="timeslots" [form]="form"></app-timeslot-view>
            </div>
            <div class="times-select range m-0"*ngIf="timeType == 'time_range' && form.get('date').value">
<!--                 <app-timeRange-view [product]="product" [time]="form.get('timeRange')" [availableFrom]="timeFrom" [availableTo]="timeTo"></app-timeRange-view>
 -->                <app-custom-timeRange [time]="form.get('timeRange')" [availableFrom]="timeFrom" [availableTo]="timeTo" [date]="form.get('date')"></app-custom-timeRange>

            </div>
        </div>
    </div>
</div>
